import {
    DOWNLOAD_INVOICES_FAILURE,
} from 'store/actions/types';

export const downloadInvoiceFailure = (error) => {
    return {
        type: DOWNLOAD_INVOICES_FAILURE,
        error,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/invoices/invoiceActions.js